/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'
const darkMode =
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      {/* <h4>
      Visualisez les changements dans la stratégie russe au cours des six derniers jours
      </h4> */}
              <div className='legend'>
      <div>
          <img
            style={{ width: '2em', display: 'inline-block' }}
            src={require('../../images/explode_picto.svg')}
          />
          Combats terrestres
        </div>
        <div>
          <span
            style={{
              width: '1em',
              height: '1em',
              backgroundColor: '#ff000055',
              display: 'inline-block',
              marginRight: '0.5em'
            }}
          />
          Zones occupées par les forces russes
        </div>
      </div>
      <div className='grid'>
        <div className='column'>
          24 février
          <img src={require(`../../images/map-1${darkMode ? '-dark' : ''}.png`)} />
        </div>
        <div className='column'>
          25 février
          <img src={require(`../../images/map-2${darkMode ? '-dark' : ''}.png`)} />
        </div>
        <div className='column'>
          26 février
          <img src={require(`../../images/map-3${darkMode ? '-dark' : ''}.png`)} />
        </div>
        <div className='column'>
          27 février
          <img src={require(`../../images/map-4${darkMode ? '-dark' : ''}.png`)} />
        </div>
        <div className='column'>
          28 février
          <img src={require(`../../images/map-5${darkMode ? '-dark' : ''}.png`)} />
        </div>
        <div className='column'>
          1er mars
          <img src={require(`../../images/map-6${darkMode ? '-dark' : ''}.png`)} />
        </div>
      </div>
      <div className='source'>
        <div>Sources: The New York Times, Institute for the Study of War</div>
        <div>© <a href='https://www.mapbox.com/about/maps/'>Mapbox</a> © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> <strong><a href='https://www.mapbox.com/map-feedback/' target='_blank' rel="noreferrer">Améliorez cette carte</a></strong></div>
      </div>
    </div>
  )
}
